/*=========================================================================================
File Name: index.js
Description: Vue Main Store File.
Version: 1.0
----------------------------------------------------------------------------------------
Item Name: V-Pizzle - VueJS Pizza & Fast Food Template
Author: Deveable
Author URL: https://www.templatemonster.com/authors/deveable/
Copyright 2021
==========================================================================================*/

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import products from './products/index';
import carts from './carts/index';

const store = new Vuex.Store({
  modules: {
    products,
    carts
  },
  state: {
    count: 0
  },
  mutations: {
    increment(state) {
      state.count++
    }
  }
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js